import React from "react";
import { Alert, Card } from "react-bootstrap";
/**
 * Renders information about the user obtained from MS Graph
 * @param props
 */
export const ProfileData = (props) => {
  const subsriptionDetails = props.graphData;
  var startDate = new Date().toLocaleDateString();
  var endDate = new Date();
  if (subsriptionDetails?.term?.termUnit === "P1Y") {
    endDate = new Date(
      endDate.setDate(endDate.getDate() + 365)
    ).toLocaleDateString();
  } else {
    endDate = new Date(
      endDate.setDate(endDate.getDate() + 31)
    ).toLocaleDateString();
  }
  // console.log({ subsriptionDetails });
  return (
    <div id="profile-div">
      <>
        <h1>Welcome to Safety Check {props.userName}!</h1>
        <br></br>
        <h6>
          Manage your licenses by selecting users and updating

        </h6>
        <h6>
          You can assign licenses to up to 10 users. To use Safety Check bot
          features for more users, please purchase additional licenses of
          Safety Check bot premium.
        </h6>
        {/* <p>
                <strong>Email: </strong> {subsriptionDetails?.purchaser.emailId}
              </p>
              <p>
                <strong>Plan Id: </strong>Premium
              </p>
              <p>
                <strong>Plan Purchased Date: </strong>
                {subsriptionDetails?.created}
              </p>
              <p>
                <strong>Plan Start Date: </strong>
                {startDate}
              </p>
              <p>
                <strong>Plan Expire Date: </strong>
                {endDate}
              </p> */}
        <p>
          <strong>License count: </strong>{" "}
          {props.licensePurchased
            ? props.licensePurchased
            : subsriptionDetails?.quantity}{" "}
          <strong>Avilable to Assign:</strong>{" "}
          {props.currentAvailableLicense
            ? props.currentAvailableLicense
            : props.teamMemberCount}
        </p>
      </>
    </div>
  );
};
